<template>
    <section class="chart-container">
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="项目">
					<el-select v-model="filters.projectId" multiple  collapse-tags   @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称" >
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn"  style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
					<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.deviceId" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn"   style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.deviceId" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="选择年">
                    <el-date-picker  v-model="filters.time"  type="year"  placeholder="选择年"  value-format="yyyy"> </el-date-picker>
                </el-form-item>
                <el-form-item label="选择季度">
                    <el-select v-model="filters.quarter"    style="width:320px"  reserve-keyword>
                        <el-option value="1" label="第一季度"></el-option>
                        <el-option value="2" label="第二季度"></el-option>
                        <el-option value="3" label="第三季度"></el-option>
                        <el-option value="4" label="第四季度"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item>
                    <my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

        <el-table :data="dataList" border  highlight-current-row v-loading="listLoading" style="width: 100%;" :height="formHeight"   size="small" >
			<el-table-column type="index" label="序号"  ></el-table-column>
            <el-table-column prop="deviceName" label="点位名称"   sortable></el-table-column>
			<el-table-column prop="functionalAreaName" label="功能区"   sortable> </el-table-column>
			<el-table-column  label="监测时间"   sortable>
                <template slot-scope="scope">
					<span>
                        {{scope.row.year}}年第{{scope.row.quarter}}季度
                    </span>
				</template>
            </el-table-column>
            <el-table-column prop="n00004" label="Ld(dB)"  ></el-table-column>
            <el-table-column prop="n00004Middle" label="Ld中位值(dB)"  ></el-table-column>
            <el-table-column prop="ldLimit" label="昼间限值(dB)"  > </el-table-column>
            <el-table-column prop="n00005" label="Ln(dB)"  ></el-table-column>
            <el-table-column prop="n00005Middle" label="Ln中位值(dB)" ></el-table-column>
            <el-table-column prop="lnLimit" label="夜间限值(dB)" > </el-table-column>
            <el-table-column prop="n00007" label="Ldn(dB)"  ></el-table-column>
            <el-table-column prop="dar" label="采集率(%)"  ></el-table-column>
            <!-- <el-table-column prop="dar_valid" label="有效采集率" ></el-table-column> -->
		</el-table>
    </section>
</template>

<script>
    import {getProjects,getDevicesByProjectId,selectStatisticsNoiseData,getFunctionalAreaList} from '../../api/api';
    import {formatDateMonth,in_array} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

	export default {
		components: { myButton },
        data() {
            return {
                filters: {
                    mn: '',
                    projectId:'',
                    quarter:"1",
                    time:""
                },
                projects:[],
                devices:[],
                dataList:[],
                listLoading:false,
                firstFlag:true,
                formHeight:0,
                dataType:'quarter',

                type:1,
                deviceMap:new Map(),
                functionalAreaMap:new Map()
            }
        },
        methods: {
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="export"){
					this.exportData();
				}
			},
            getFunctionalAreaList(){
				getFunctionalAreaList({}).then((res) => {
					
					res.data.data.forEach(element => {
						this.functionalAreaMap.set(element.id,element);
					});
				    this.getProjects();
				});
			},
              //获取选中设备可监测的因子
              getFactorsByMn(){
                if(this.filters.mn.toString()==""){
                    return;
                }
                if(in_array('-2',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                if(in_array('-1',this.filters.mn)){
                    this.filters.mn=[];
                    this.devices.forEach(element => {
                        this.filters.mn.push(element.deviceId);
                    });
                }
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
			getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
			        if(this.projects.length>0){
                        this.filters.projectId=[];
                        this.filters.projectId.push(this.projects[0].projectId);
						this.getDevices();
					}
				});
			},
            //获取趋势分析数据
            getDataList(){
                let para = {
                    deviceIds: this.filters.mn.toString(),
                    dataType:this.dataType,
                    time: this.filters.time,
                    quarter:this.filters.quarter
                };
                this.listLoading = true;
                
				selectStatisticsNoiseData(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result==true||res.data.result=="true"){
                        this.dataList = res.data.datas;
                        for (let index = 0; index < this.dataList.length; index++) {
                            const element = this.dataList[index];
                            var funid=element.functionalAreaId;
                            element.ldLimit=this.functionalAreaMap.get(funid).day;
                            element.lnLimit=this.functionalAreaMap.get(funid).night;
                        }
                    }else{
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
						return;
                    }
				}).catch(() => {
					this.listLoading = false;
				});
            },
            //获取设备列表
			getDevices() {
                 if(this.filters.projectId.toString()==""){
                    return;
                }
                this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId.toString()
                };
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    
                    this.devices = res.data.data;
                    this.filters.mn=[];
                    if( this.devices.length>0){
                        this.filters.mn.push(res.data.data[0].deviceId);
                    }
                    this.getDataList();
				});
            },
            exportData(){
                require.ensure([], () => {
                    const { export_json_to_excel } = require('vendor/Export2Excel');

                    const tHeader =  ['点位名称',"功能区", '监测时间','Ld','Ld中位值',"昼间限值", 'Ln' ,'Ln中位值',"夜间限值", 'Ldn', '采集率' ];
                    const filterVal = ['deviceName',"functionalAreaName", 'time', 'n00004','n00004Middle',"ldLimit",'n00005','n00005Middle',"lnLimit",'n00007','dar']; 

                    var data=[];
                    var sheetName=[];
                    data.push(this.formatJson(filterVal, this.dataList));
                    sheetName.push('Sheet1');

                    export_json_to_excel(tHeader, data, '季度数据统计',sheetName);
                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var start = new Date();
                var month=start.getMonth();//5-1 显示4

                if(month>3){//当年已经过完第一季度
                    this.filters.time= start.getFullYear().toString();
                    this.filters.quarter=parseInt( month/3);
                }else{//选取去年最后一季度
                    start.setTime(start.setFullYear(start.getFullYear()-1));
                    this.filters.time= start.getFullYear().toString();
                    this.filters.quarter="4";
                }

			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
            },10)
            this.setTime();
            this.type=sessionStorage.getItem("type");
            this.getFunctionalAreaList();
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
    .dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
    .tabSelect{
		color: #fff;
		background: #409eff;
	}
</style>



// WEBPACK FOOTER //
// QuarterData.vue?f6a13476